import { render } from "./Penalty_Batches.vue?vue&type=template&id=26ab2d81&scoped=true"
import script from "./Penalty_Batches.vue?vue&type=script&lang=js"
export * from "./Penalty_Batches.vue?vue&type=script&lang=js"

import "./Penalty_Batches.vue?vue&type=style&index=0&id=26ab2d81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ab2d81"]])

export default __exports__